import styled from 'styled-components';

import { FlexColumn, StyleUtils } from '@main/core-ui';

export const DropZoneWrapper = styled(FlexColumn)`
  border: 2px dashed ${({ theme }) => theme.colors.transcendNavy4};
  border-radius: 0.9em;
  padding: ${StyleUtils.Spacing.md};
  gap: ${StyleUtils.Spacing.md};
  transition:
    background-color 0.3s ease-in-out,
    border 0.3s ease-in-out;
  cursor: pointer;

  :hover {
    border-color: ${({ theme }) => theme.colors.transcendNavy3};
  }
`;
